module.exports = __webpack_public_path__ + "img/certificaciones-adobe.63303d9d.jpg";